import jwtDecode from "jwt-decode";
import { aws } from "../api";
import history from "../history";

import {
  GET_WELCOME,
  SIGN_IN,
  SIGN_OUT,
  REOPEN_SESSION,
  GET_REMINDERS,
  GET_TRAINING,
  GET_VC,
  GET_SETUP_INFO,
  EDIT_SETUP_INFO,
  ADD_VC,
  DELETE_VC,
} from "./types";

export const getWelcome = () => async (dispatch) => {
  const res = await aws({
    method: "GET",
    url: "/welcome",
  });
  dispatch({
    type: GET_WELCOME,
    payload: res.data,
  });
};

export const getTraining = () => async (dispatch, getState) => {
  const currState = getState();
  const { jwt } = currState.auth;
  const res = await aws({
    method: "GET",
    url: "/training",
    headers: {
      Authorization: jwt,
    },
  });
  let data;
  res.data.statusCode === 200
    ? (data = JSON.parse(res.data.body))
    : (data = res.data.body);
  dispatch({
    type: GET_TRAINING,
    payload: data,
  });
};

export const getVc = () => async (dispatch, getState) => {
  const currState = getState();
  const { jwt } = currState.auth;
  const res = await aws({
    method: "GET",
    url: "/vc",
    headers: {
      Authorization: jwt,
    },
  });
  let data;
  res.data.statusCode === 200
    ? (data = JSON.parse(res.data.body))
    : (data = res.data.body);
  dispatch({
    type: GET_VC,
    payload: data,
  });
};

export const getReminders = () => async (dispatch) => {
  const res = await aws({
    method: "GET",
    url: "/reminders",
  });
  dispatch({
    type: GET_REMINDERS,
    payload: JSON.parse(res.data),
  });
};

export const signIn = (cognitoUser, cognitoUserSession) => async (dispatch) => {
  cognitoUser.setDeviceStatusRemembered({
    onSuccess: function (result) {
      // console.log("call result: " + result);
    },
    onFailure: function (err) {
      console.log(err.message || JSON.stringify(err));
    },
  });
  const jwt = cognitoUserSession.getIdToken().getJwtToken();
  const jwtInfo = jwtDecode(jwt);
  const groups = jwtInfo["cognito:groups"];
  const username = jwtInfo["cognito:username"];
  const name = jwtInfo.name;
  let isAdmin = false;
  let isSupervisor = false;
  if (groups) {
    groups.includes("Administrators") ? (isAdmin = true) : (isAdmin = false);
    groups.includes("Supervisors")
      ? (isSupervisor = true)
      : (isSupervisor = false);
  }
  history.push("/welcome");
  dispatch({
    type: SIGN_IN,
    payload: { username, isAdmin, jwt, name, isSupervisor },
  });
};

export const reopenSession = (jwt) => {
  let isAdmin = false;
  let isSupervisor = false;
  const jwtInfo = jwtDecode(jwt);
  const groups = jwtInfo["cognito:groups"];
  const username = jwtInfo["cognito:username"];
  const name = jwtInfo.name;
  if (groups) {
    groups.includes("Administrators") ? (isAdmin = true) : (isAdmin = false);
    groups.includes("Supervisors")
      ? (isSupervisor = true)
      : (isSupervisor = false);
  }
  return {
    type: REOPEN_SESSION,
    payload: { username, isAdmin, jwt, name, isSupervisor },
  };
};

export const logOut = (cognitoUser) => async (dispatch) => {
  // if (cognitoUser != null) {
  //   cognitoUser.getSession(function (err, session) {
  //     if (err) {
  //       alert(err.message || JSON.stringify(err));
  //       return;
  //     }
  //     console.log("session validity: " + session.isValid());
  //     cognitoUser.signOut({
  //       onSuccess: (result) => {
  //         console.log(result);
  //       },
  //       onFailure: (err) => {
  //         console.log("Error signing out: ", err);
  //       },
  //     });
  //   });
  // }
  cognitoUser.signOut();
  history.push("/logout");
  dispatch({
    type: SIGN_OUT,
  });
};

export const getSetupInfo = () => async (dispatch, getState) => {
  const currState = getState();
  const { jwt } = currState.auth;
  let data;

  const res = await aws({
    method: "GET",
    url: "/admin",
    headers: {
      Authorization: jwt,
    },
  });
  res.data.statusCode === 200
    ? (data = JSON.parse(res.data.body).rows)
    : (data = res.data.body);
  dispatch({
    type: GET_SETUP_INFO,
    payload: { data },
  });
};

export const editSetupInfo = (vcid, vcInfo) => async (dispatch, getState) => {
  const currState = getState();
  const { jwt } = currState.auth;
  const rows = currState.admin.setupTimes;

  let data, updatedData;
  try {
    const res = await aws({
      method: "PUT",
      url: `/admin/edit/${vcid}`,
      headers: {
        Authorization: jwt,
      },
      data: {
        vcInfo: JSON.stringify(vcInfo),
      },
    });
    if (res.data.statusCode === 200) {
      data = [JSON.parse(res.data.body)][0];
      const indexOfVcid = rows.findIndex((row) => {
        return row.VCID === data.VCID;
      });
      rows[indexOfVcid] = data;
      updatedData = { rows: rows, error: false };
      history.push("/admin");
    } else {
      data = res.data.body.message;
      updatedData = { rows: rows, error: true, errorDescription: data };
    }
  } catch (err) {
    data = err.message;
    updatedData = { rows: rows, error: true, errorDescription: data };
  } finally {
    dispatch({
      type: EDIT_SETUP_INFO,
      payload: { updatedData },
    });
  }

  // let data;
  // res.data.statusCode === 200
  //   ? (data = [JSON.parse(res.data.body)][0])
  //   : (data = res.data.body);
  // const indexOfVcid = rows.findIndex((row) => {
  //   return row.VCID === data.VCID;
  // });
  // rows[indexOfVcid] = data;
  // history.push("/admin");
  // const updatedData = {
  //   rows: rows,
  // };
};

export const addVc = (vcInfo) => async (dispatch, getState) => {
  const currState = getState();
  const { jwt } = currState.auth;
  const rows = currState.admin.setupTimes;

  let data, updatedData;
  try {
    const res = await aws({
      method: "POST",
      url: `/admin/add`,
      headers: {
        Authorization: jwt,
      },
      data: {
        vcInfo: JSON.stringify(vcInfo),
      },
    });
    if (res.data.statusCode === 200) {
      data = [JSON.parse(res.data.body)][0];
      rows.push(data);
      updatedData = { rows: rows, error: false };
      history.push("/admin");
    } else {
      data = res.data.body.message;
      updatedData = { rows: rows, error: true, errorDescription: data };
    }
  } catch (err) {
    data = err.message;
    updatedData = { rows: rows, error: true, errorDescription: data };
  } finally {
    dispatch({
      type: ADD_VC,
      payload: { updatedData },
    });
  }
};

export const deleteVc = (vcid) => async (dispatch, getState) => {
  const currState = getState();
  const { jwt } = currState.auth;
  const rows = currState.admin.setupTimes;

  let data, updatedData;

  try {
    const res = await aws({
      method: "DELETE",
      url: `/admin/delete/${vcid}`,
      headers: {
        Authorization: jwt,
      },
    });

    if (res.data.statusCode === 200) {
      data = [JSON.parse(res.data.body)][0];
      const indexOfVcid = rows.findIndex((row) => {
        return row.VCID === data.VCID;
      });
      rows.splice(indexOfVcid, 1);
      updatedData = { rows: rows, error: false };
      history.push("/admin");
    } else {
      data = res.data.body.message;
      updatedData = { rows: rows, error: true, errorDescription: data };
    }
  } catch (err) {
    data = err.message;
    updatedData = { rows: rows, error: true, errorDescription: data };
  } finally {
    dispatch({
      type: DELETE_VC,
      payload: { updatedData },
    });
  }
};
